import { TopInfoTypes } from "../../../types/types";

interface props {
  info: TopInfoTypes
}

export const TopInfo: React.FC<props> = ({ info }) => (
  <div className="gm-top-title-container">
    <span className="gm-top-title-label">{info.title}</span>
    {info?.subtitle && <span className="gm-top-subtitle">{info.subtitle}</span>}
  </div>
);